import React, { createContext, useState , useEffect } from 'react';

import {getTeriffData} from '../loginPageService'
import { textareaClasses } from '@mui/joy';

export const CommonContext = createContext();

export const CommonContextProvider = ({ children }) => {
  const [welcomeModal, setWelcomeModal] = useState(true); 
  
  const [rideBookingModal,setRideBookingModal] = useState(false);

  const [teriffData , setTeriffData ] = useState({localPackage:[],commonPackage:[],yercaudPackage:[]});
 
  const [teriffDataObject , setTeriffDataObject] = useState({
    localPackage: {
        title: 'Local Package',
        columns: ['Vehicle Type', '40 Km 4Hrs', '80 Km 4Hrs', '120 Km 6Hrs', 'Out station Per Km', 'Waiting 1Hrs'],
        rows: [],
    },
    yercardPackage: {
        title: 'Yercard Package',
        columns: ['Vehicle Type', 'Drop Yercard', 'Drop Package', 'Km', 'Amount', 'Add Km', 'Add Hrs'],
        rows:[],
    }
  });

  useEffect(()=>{
    data();
  },[])


  async function getTeriff() {

    try {
        // Wait for the API call to complete
        const response = await getTeriffData();

        // Handle the response here
        if (response.status === 200) {
          setTeriffData(response.data);
          
        } 
    } catch (error) {
        // Handle network or other error
        console.error('Error during login:', error);
    }
}


const data = () =>{

  const teriffDataObject = {
    localPackage: {
      title: 'Local Package',
      columns: ['Vehicle Type', '40 Km 4Hrs', '80 Km 4Hrs', '120 Km 6Hrs', 'Out station Per Km', 'Waiting 1Hrs'],
      rows: [
        { 'Vehicle Type': 'EEco', '40 Km 4Hrs': 790, '80 Km 4Hrs': 1310, '120 Km 6Hrs': 1830, 'Out station Per Km': 13, 'Waiting 1Hrs': '80Rs' },
        { 'Vehicle Type': 'Indico', '40 Km 4Hrs': 640, '80 Km 4Hrs': 1120, '120 Km 6Hrs': 1600, 'Out station Per Km': 12, 'Waiting 1Hrs': '80Rs' },
        { 'Vehicle Type': 'swift/Etios', '40 Km 4Hrs': 690, '80 Km 4Hrs': 1210, '120 Km 6Hrs': 1730, 'Out station Per Km': 13, 'Waiting 1Hrs': '80Rs' },
        { 'Vehicle Type': 'Tavera/Xylo', '40 Km 4Hrs': 920, '80 Km 4Hrs': 1520, '120 Km 6Hrs': 2120, 'Out station Per Km': 15, 'Waiting 1Hrs': '100Rs' },
        { 'Vehicle Type': 'Innova', '40 Km 4Hrs': 1400, '80 Km 4Hrs': 2200, '120 Km 6Hrs': 3000, 'Out station Per Km': 19, 'Waiting 1Hrs': '120Rs' },
      ],
    },
    yercardPackage: {
      title: 'Yercard Package',
      columns: ['Type', 'Drop Yercard', 'Drop Package', 'Km', 'Amount', 'Add Km', 'Add Hrs'],
      rows: [
        { 'Type': 'EEco', 'Drop Yercard': 1500, 'Drop Package': 6, 'Km': 80, 'Amount': 1900, 'Add Km': 17.0, 'Add Hrs': 90 },
      { 'Type': 'Indico', 'Drop Yercard': 1100, 'Drop Package': 6, 'Km': 80, 'Amount': 1500, 'Add Km': 16.0, 'Add Hrs': 90 },
      { 'Type': 'Sedan', 'Drop Yercard': 1300, 'Drop Package': 6, 'Km': 80, 'Amount': 1700, 'Add Km': 17.0, 'Add Hrs': 90 },
      { 'Type': 'Tavera/Xylo', 'Drop Yercard': 1900, 'Drop Package': 6, 'Km': 80, 'Amount': 2400, 'Add Km': 21.0, 'Add Hrs': 100 },
      { 'Type': 'Innova', 'Drop Yercard': 2100, 'Drop Package': 6, 'Km': 80, 'Amount': 3500, 'Add Km': 26.0, 'Add Hrs': 100 },
   ],
    },
  };

  setTeriffDataObject(teriffDataObject);
};


const getTeriffDataList = () =>{
  return teriffDataObject;
}

useEffect(() => {
  if (teriffData) {
    data(); // Call the function that needs the updated data
  }
}, [teriffData]);





  return (
    <CommonContext.Provider value={{ welcomeModal, setWelcomeModal,rideBookingModal,setRideBookingModal,getTeriffDataList }}>
      {children}
    </CommonContext.Provider>
  );
};
